<template>
	<dv-border-box-12 class="lineBox">
		<div class="box">
			<div class="box_title">管理</div>
			<div class="prizeList">
				<div class="prize_left">
					<div class="prize_title">中国专利奖获奖统计</div>
					<div class="prizeNumList" >
						<div class="prizeItem" v-for="(item,index) in zgprizeList" :key="index" @click="toPrize('zg',item)">
							<div class="prize_name">
								<img src="@/assets/patent/diamond-1.png" v-if="item.type == 1">
								<img src="@/assets/patent/diamond-2.png" v-if="item.type == 2">
								<img src="@/assets/patent/diamond-3.png" v-if="item.type == 3">
								<div :class="[item.type == 1 ? 'gold' : (item.type == 2 ? 'silver' : 'excellent')]">{{item.title}}</div>
							</div>
							<div class="prize_nums">
								<countTo :startVal='0' :endVal='Number(item.num)' :duration='800'></countTo>项
							</div>
						</div>
					</div>
				</div>
				<div class="prize_left">
					<div class="prize_title1">第十届安徽省专利奖</div>
					<div class="prizeNumList" >
						<div class="prizeItem" v-for="(item,index) in ahprizeList" :key="index" @click="toPrize('ah',item)">
							<div class="prize_name">
								<img src="@/assets/patent/diamond-1.png" v-if="item.type == 1">
								<img src="@/assets/patent/diamond-2.png" v-if="item.type == 2">
								<img src="@/assets/patent/diamond-3.png" v-if="item.type == 3">
								<div :class="[item.type == 1 ? 'gold' : (item.type == 2 ? 'silver' : 'excellent')]">{{item.title}}</div>
							</div>
							<div class="prize_nums">
								<countTo :startVal='0' :endVal='Number(item.num)' :duration='800'></countTo>项
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="advantage">
				<div class="exampleList_left" @click="toDetail">
					<vue-seamless-scroll :data="marqueeList" :class-option="optionSingleHeight" class="seamless-warp">
					    <ul class="seamless-warp-items">
					        <li class="marqueeItem" v-for="(item,index) in marqueeList" :key="index" :data-index="index">
								<span class="yuan"></span>
					            <div class="title">{{item.name.slice(0,6)}}</div>
								<div class="subtitle">{{item.name.slice(6)}}</div>
					        </li>
					    </ul>
					</vue-seamless-scroll>
				</div>
				<div class="exampleList_right">
					<el-popover placement="top"  trigger="hover" width="180" v-model="visible">
					  <p>合肥高新技术产业开发区</p>
					  <div class="test_title" slot="reference">国家知识产权服务业集聚发展试验区&nbsp;1个</div>
					</el-popover>
					<div class="testList">
						<div class="textItem" v-for="(item,index) in testList" :key="index">
							<div class="textItem_title">{{item.title}}</div>
							<div class="textItem_num">
								<countTo :startVal='0' :endVal='Number(item.jia)' :duration='800'></countTo>家
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</dv-border-box-12>
</template>

<script>
	export default {
		data() {
			return {
				visible:false,
				zgprizeList:[],
				ahprizeList:[],
				marqueeList: [
					{
						name: '国家传统知识知识产权保护示范县:1个',
						childs:['安徽省黄山市歙县'],
					},{
						name: '国家传统知识知识产权保护试点县(区):3个',
						childs:['安徽省芜湖市镜湖区','安徽省宣城市泾县、绩溪县'],
					},{
						name: '国家知识产权示范城市：4个',
						childs:['安徽芜湖', '安徽合肥','安徽马鞍山','安徽宁国'],
					},{
						name: '国家知识产权示点城市：4个',
						childs:['安徽蚌埠市','安徽铜陵市','安徽安庆市','安徽淮北'],
					},{
						name: '国家知识产权强县工程示范县：15个',
						childs:['安徽省合肥市肥西县、包河区','安徽省芜湖市繁昌县、无为县、芜湖县、弋江区、鸠江区','安徽省蚌埠市怀远县、蚌山区','安徽省六安市霍山县','安徽省铜陵市铜官区','安徽省滁州市全椒县、天长市','安徽省池州市青阳县','安徽省马鞍山市和县'],
					},{
						name: '全国强县工程试点县：18个',
						childs:['合肥市蜀山区','淮北市杜集区、濉溪县、相山区','阜阳市颍泉区、颍上县','蚌埠市禹会区','滁州市明光市、南谯区','六安市舒城县','芜湖市三山区、南陵县','宣城市旌德县、广德县、郎溪县','黄山市休宁县','安庆市桐城市','亳州市涡阳县'],
					},{
						name: '国家知识产权示范园区：2个',
						childs:['合肥高新技术产业开发区','芜湖经济技术开发区'],
					},{
						name: '国家知识产权试点园区：6个',
						childs:['芜湖高新技术产业开发区','马鞍山慈湖高新技术产业开发区','蚌埠高新技术产业开发区','宁国经济技术开发区','宣城高新技术产业开发区','界首高新技术产业开发区'],
					},
				],
				testList:[
					{
						title:'国家知识产权示范企业',
						jia:71,
					},{
						title:'国家知识产权优势企业',
						jia:308,
					},{
						title:'知识产权贯标认证企业',
						jia:470,
					},{
						title:'安徽省知识产权专家库',
						jia:296,
					},{
						title:'安徽省知识产权专员',
						jia:8877,
					},
				],
			}
		},
		computed: {
			optionSingleHeight () {
				return {
					singleHeight:32
				}
			}
		 },
		methods:{
			getData(data1,data2){
				this.zgprizeList = [
					{
						type:1,
						title:'专利金奖',
						num:data1.zljj,
					},{
						type:1,
						title:'外观设计金奖',
						num:data1.wgsjjj,
					},{
						type:2,
						title:'专利银奖',
						num:data1.zlyj,
					},{
						type:2,
						title:'外观设计银奖',
						num:data1.wgsjyj,
					},{
						type:3,
						title:'专利优秀奖',
						num:data1.zlyxj,
					},{
						type:3,
						title:'外观设计优秀奖',
						num:data1.wgsjyxj,
					}
				]
				this.ahprizeList = [
					{
						type:1,
						title:'专利金奖',
						num:data2.zljj,
					},{
						type:1,
						title:'外观设计金奖',
						num:data2.wgsjjj,
					},{
						type:2,
						title:'专利银奖',
						num:data2.zlyj,
					},{
						type:2,
						title:'外观设计银奖',
						num:data2.wgsjyj,
					},{
						type:3,
						title:'专利优秀奖',
						num:data2.zlyxj,
					},{
						type:3,
						title:'外观设计优秀奖',
						num:data2.wgsjyxj,
					}
				]
			},
			// vue-seamless-scroll 点击不生效
			toDetail(e){
				const item = e.target.closest(".marqueeItem"); // 定位元素
				if (item) { // 是否是滚动组件的某一行/列
					const { index } = item.dataset;
					this.$emit('toManageDetail',2,this.marqueeList[index])
				}
			},
			// 奖项详情
			toPrize(type,item){
				if(item.type == 3)return
				item.classify = type
				this.$emit('toManageDetail',1,item)
			},
		}
	}
</script>
<style type="text/css">
	.el-popover{
		background:#91D5FF;
		color:#003A8C;
		font-size:0.14rem;
		border: none;
	}
	.el-popper[x-placement^=top] .popper__arrow::after{
		border-top-color:#91D5FF !important;
	}
</style>
<style lang="scss" scoped>
	
</style>
